import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { BaseDialogOptions } from '../dialogoptions';
var ReportOptionsDialogComponent = /** @class */ (function () {
    function ReportOptionsDialogComponent(dialogRef, data, fb) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.fb = fb;
        this.title = data.TitleText || 'Information';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.AllSchoolYears = data.AllSchoolYears || [];
        this.ReportInfo = data.ReportInfo;
        var syear = this.AllSchoolYears && !!this.AllSchoolYears.length ? this.AllSchoolYears[0] : null;
        this.OptionsForm = this.fb.group({
            ReportYear: [syear, Validators.required],
        });
    }
    ReportOptionsDialogComponent.prototype.ngOnInit = function () { };
    ReportOptionsDialogComponent.prototype.CancelHandler = function () {
        this.dialogRef.close(null);
    };
    ReportOptionsDialogComponent.prototype.OKHandler = function () {
        var form = this.OptionsForm.value;
        this.dialogRef.close({
            ReportInfo: this.ReportInfo,
            ReportSchool: form.ReportSchool,
            ReportYear: form.ReportYear,
            ReportJudgingPhase: form.ReportJudgingPhase,
        });
    };
    return ReportOptionsDialogComponent;
}());
export { ReportOptionsDialogComponent };
var BaseReportOptionsDialogOptions = /** @class */ (function (_super) {
    tslib_1.__extends(BaseReportOptionsDialogOptions, _super);
    function BaseReportOptionsDialogOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseReportOptionsDialogOptions;
}(BaseDialogOptions));
export { BaseReportOptionsDialogOptions };
var BaseReportOptionsResult = /** @class */ (function () {
    function BaseReportOptionsResult() {
    }
    return BaseReportOptionsResult;
}());
export { BaseReportOptionsResult };
